module.exports = __webpack_public_path__ + "img/pocket_entry_length.601b413b.png";